"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Modal = void 0;
var _Icon = require("../Icon/Icon");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _modalModule = _interopRequireDefault(require("@albelli/arc-3/lib/modal.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Modal = _ref => {
  let {
    children,
    isOpen,
    onClose,
    light,
    fullWidth,
    semiFullWidth,
    className,
    ...props
  } = _ref;
  const classNames = (0, _classnames.default)(className, [_modalModule.default["arc3-modal"], _modalModule.default["--opened"], _modalModule.default["--opaque"]], {
    [_modalModule.default["--light"]]: light,
    [_modalModule.default["--dismissible"]]: typeof onClose !== "undefined",
    [_modalModule.default["--full-width"]]: fullWidth,
    [_modalModule.default["--semi-full-width"]]: semiFullWidth
  });
  return !!isOpen ? /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classNames,
    onClick: () => {
      if (isOpen && onClose) onClose();
    },
    "data-cy": "arc3-modal"
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: _modalModule.default["arc3-modal__content"],
    onClick: e => {
      e.stopPropagation();
    }
  }, onClose && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_modalModule.default["arc3-modal__close"], "arc3-pointer"),
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: "close"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _modalModule.default["arc3-modal__content__wrapper"]
  }, children))) : null;
};
exports.Modal = Modal;
Modal.propTypes = {
  /** Optional custom CSS classes */
  className: _propTypes.default.string,
  /** Content */
  children: _propTypes.default.oneOfType([_propTypes.default.node]).isRequired,
  /** Set true open dialog, set false to close */
  isOpen: _propTypes.default.bool,
  /** onClose handler required to handle popup vs modal */
  onClose: _propTypes.default.func,
  /** Light or Dark background layer */
  light: _propTypes.default.bool,
  /** Make a modal full-width (max-width 1440px) */
  fullWidth: _propTypes.default.bool,
  /** Make a modal semi full-width (max-width 1280) */
  semiFullWidth: _propTypes.default.bool
};
var _default = exports.default = Modal;